/* eslint-disable import/no-extraneous-dependencies */
import "requestidlecallback-polyfill";

const noop = () => {};
/* eslint-disable */
// Add empty method due to script error
if (!window._AutofillCallbackHandler) {
  window._AutofillCallbackHandler = noop;
}

// Add empty method if Google Analytics  blocked
// Creates an initial ga() function.
// The queued commands will be executed once analytics.js loads.
window.GoogleAnalyticsObject = "ga";
window.ga =
  window.ga ||
  function () {
    // eslint-disable-next-line prefer-rest-params
    (window.ga.q = window.ga.q || []).push(arguments);
  };
// Sets the time (as an integer) this tag was executed.
// Used for timing hits.
window.ga.l = 1 * new Date();

// Fix Safari 14
(function() {
	if (!Array.prototype.at) {
		Array.prototype.at = function (index) {
			// Convert the index to an integer
			index = Math.trunc(index) || 0;

			// Handle negative index
			if (index < 0) {
				index += this.length;
			}

			// Return undefined if the index is out of bounds
			if (index < 0 || index >= this.length) {
				return undefined;
			}

			// Return the element at the given index
			return this[index];
		};
	}
}());
